import { useMutation, useQueryClient } from '@tanstack/react-query'

import { replaceVariant } from '../api'
import { contentKeys } from '../queryKeys'

const useReplaceVariantMutation = (contentId) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: replaceVariant,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: contentKeys.content(contentId),
      })
    },
  })
}

export default useReplaceVariantMutation
